import React from 'react';
import { FiFileText } from 'react-icons/fi';
import { isPreviewableImage, getFileExtension } from '../../util/attachmentHelper';

/**
 * Renders an attachment preview:
 * - JPEG/PNG/WebP -> real <img> preview
 * - PDF/TXT/other -> generic file badge with extension + click to open
 *
 * Shared between Account and Transaction attachment sections so both
 * resources display allowed file types (images, PDF, TXT) consistently.
 */
const AttachmentFilePreview = ({
    url,
    filename,
    imgError,
    onImgError,
    onClick,
    className = '',
    alt = 'Attachment',
    clickable = true,
}) => {
    const previewable = isPreviewableImage(filename || url);

    if (previewable && !imgError) {
        return (
            <img
                src={url}
                alt={alt}
                className={className}
                onError={onImgError}
                onClick={clickable ? onClick : undefined}
                style={{ cursor: clickable ? 'zoom-in' : 'default' }}
            />
        );
    }

    const ext =
        getFileExtension(filename || url)
            .replace('.', '')
            .toUpperCase() || 'FILE';

    return (
        <div
            className={`attachment-file-badge ${className}`}
            onClick={clickable ? onClick : undefined}
            style={{ cursor: clickable ? 'pointer' : 'default' }}
        >
            <FiFileText size={32} className="file-badge-icon" />
            <span className="file-badge-ext">{ext}</span>
        </div>
    );
};

export default AttachmentFilePreview;
